import { useNavigate } from "react-router-dom";
import RolesList from "../../features/manageSubAdmin/rolesList";
import usePermission from "../../hooks/userAccess";

const ManageSubadminRoles = () => {
  const navigate = useNavigate();

  const { isView } = usePermission({
    label: 'Manage Sub-Admin',
    page_permission: 'isView',
  })

  return (
    <>
      <div className="main_title">
        <h1>Manage Roles</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button>
          {' '} - <button onClick={() => navigate("/manage-subadmin")}>Manage Sub-Admin</button>
          {' '} - Manage Roles
        </p>
      </div>

      {isView && <div className="cards">
        <RolesList />
      </div>}
    </>
  );
};

export default ManageSubadminRoles;
